function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("rect", {
  x: 0.75,
  y: 0.75,
  width: 26.5,
  height: 46.5,
  rx: 4.25,
  fill: "#EAF3FF",
  stroke: "#2E77D0",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("rect", {
  x: 3.864,
  y: 5.236,
  width: 20,
  height: 6.982,
  rx: 1,
  fill: "#2E77D0"
});

var _ref3 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 14.836,
  width: 22,
  height: 3.491,
  rx: 1,
  fill: "#2E77D0",
  fillOpacity: 0.09
});

var _ref4 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 32.291,
  width: 12,
  height: 3.491,
  rx: 1,
  fill: "#2E77D0",
  fillOpacity: 0.09
});

var _ref5 = /*#__PURE__*/React.createElement("rect", {
  x: 3,
  y: 20.073,
  width: 22,
  height: 9.6,
  rx: 1,
  fill: "#2E77D0",
  fillOpacity: 0.09
});

var _ref6 = /*#__PURE__*/React.createElement("rect", {
  x: 8,
  width: 12,
  height: 2.182,
  rx: 1,
  fill: "#2E77D0"
});

function SvgForeground(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 28 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _ref, _ref2, _ref3, _ref4, _ref5, _ref6);
}

export default SvgForeground;